var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasFullShared(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "222.79pt",
    height: "354.69pt",
    viewBox: "-106 0 222.79 354.69",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(4.5092 0 0 4.5092 371.98 0)",
    strokeWidth: 0.15363
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-73.451 71.879h-18.987c-2.4737 0-4.7848 0.69855-6.7815-0.4585v3.1705c0 2.2475 1.822 4.0689 4.0689 4.0689h24.411c2.2475 0 4.0689-1.8214 4.0689-4.0689v-3.1705c-1.9966 1.157-4.3071 0.4585-6.7808 0.4585z",
    fill: "#0b1728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-74.807 0h-16.275c-1.4961 0.0042009-2.7078 1.2165-2.712 2.7126v14.986c0.4477-0.04081 0.89479-0.06781 1.3563-0.06781h18.987c0.4609 0 0.90859 0.02701 1.3563 0.06781v-14.986c-0.0048-1.4961-1.2165-2.7084-2.7126-2.7126zm-2.7126 9.4934c0 0.74896-0.60733 1.3563-1.3563 1.3563h-8.1371c-0.74896 0-1.3563-0.60733-1.3563-1.3563v-2.7126c0-0.74896 0.60733-1.3563 1.3563-1.3563h8.1371c0.74896 0 1.3563 0.60733 1.3563 1.3563z",
    fill: "#3771c8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-92.438 16.274h18.987c7.4902 0 13.562 6.0721 13.562 13.562v29.837c0 7.4902-6.0715 13.562-13.562 13.562h-18.987c-7.4902 0-13.562-6.0721-13.562-13.562v-29.837c0-7.4902 6.0721-13.562 13.562-13.562z",
    fill: "#008000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-82.944 61.029c-2.7126 0-10.85-0.51431-10.85-8.2308 0.12243-2.5457 1.2429-4.9409 3.1189-6.6662 0.0252-0.02281 0.06301-0.02701 0.09242-0.0096 0.02941 0.0174 0.04381 0.05281 0.03541 0.08582-0.29046 0.84918-0.97101 3.5029 2.1701 3.5029 1.085 0 2.1695-0.51371 2.1695-2.5764 0-2.0632-2.712-4.1163-2.712-7.2033 0-3.4231 2.0464-8.2728 5.9671-8.7433 0.06901-0.01079 0.13623 0.02641 0.16384 0.09062 0.027 0.06421 0.0072 0.13863-0.04861 0.18064-0.99801 0.60613-1.6438 1.6552-1.7344 2.8194 0 6.1735 12.477 8.2308 12.477 18.519 0 7.7165-8.1377 8.2308-10.85 8.2308z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.21234 0 0 .21234 8.072 16.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m321.07 317.79-57.346-33.939v-61.051c0-4.267-3.459-7.726-7.726-7.726s-7.726 3.459-7.726 7.726v61.051l-54.175 32.063c-3.673 2.173-4.887 6.912-2.714 10.584 1.443 2.438 4.016 3.792 6.657 3.792 1.338 0 2.693-0.348 3.928-1.078l54.03-31.978 57.202 33.854c1.235 0.731 2.59 1.078 3.928 1.078 2.641 0 5.214-1.355 6.657-3.792 2.173-3.672 0.958-8.411-2.715-10.584z",
    fill: "#efecef"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 116.55,
    r: 116.55,
    fill: "#62a4fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.24 20.652c13.018 18.811 20.652 41.634 20.652 66.243 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.243-20.652 21.035 30.395 56.139 50.31 95.901 50.31 64.37 0 116.55-52.182 116.55-116.55 1e-3 -39.762-19.915-74.866-50.31-95.901z",
    fill: "#5392f9"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 74.927,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 116.55c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.151-19.216-42.105-31.317-69.888-31.317z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 395.45,
    cy: 395.45,
    r: 116.55,
    fill: "#b3e59f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m461.69 299.55c13.018 18.811 20.652 41.634 20.652 66.242 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.242-20.652 21.035 30.395 56.139 50.31 95.901 50.31 64.37 1e-3 116.55-52.181 116.55-116.55 0-39.762-19.916-74.866-50.31-95.901z",
    fill: "#95d6a4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 395.45,
    cy: 353.82,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.45 395.45c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.151-19.216-42.105-31.317-69.888-31.317z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 116.55,
    cy: 395.45,
    r: 116.55,
    fill: "#e27f86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m182.8 299.55c13.018 18.811 20.652 41.634 20.652 66.242 0 64.37-52.182 116.55-116.55 116.55-24.609 0-47.431-7.633-66.243-20.652 21.036 30.395 56.14 50.311 95.902 50.311 64.37 0 116.55-52.182 116.55-116.55 0-39.762-19.916-74.866-50.311-95.901z",
    fill: "#df646e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7fe"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116.55,
    cy: 353.82,
    r: 41.626
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.55 395.45c-27.783 0-52.737 12.101-69.888 31.317-3.029 3.394-3.389 8.394-1 12.265 14.671 23.781 40.953 39.67 70.888 39.67s56.217-15.889 70.888-39.67c2.388-3.871 2.029-8.871-1-12.265-17.152-19.216-42.105-31.317-69.888-31.317z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasFullShared);
export default __webpack_public_path__ + "static/media/gas_full-shared.7531215059d0b8c685b4edf83d4234c8.svg";
export { ForwardRef as ReactComponent };